import { render, staticRenderFns } from "./MessageInputTextarea.vue?vue&type=template&id=01ccce60&scoped=true&"
import script from "./MessageInputTextarea.vue?vue&type=script&lang=js&"
export * from "./MessageInputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MessageInputTextarea.vue?vue&type=style&index=0&id=01ccce60&prod&lang=scss&"
import style1 from "./MessageInputTextarea.vue?vue&type=style&index=1&id=01ccce60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ccce60",
  null
  
)

export default component.exports